<template>
    <navBar title="Ares - Finance" :home="true" type="hefc"/>
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
        components: {
            navBar,
        },
    }
</script>  

